module.exports = __webpack_public_path__ + "static/media/heart.8e29b0fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/heart.svg
// module id = 76
// module chunks = 0